import styled from "styled-components";
import { ColorProps, GlobalColorPalette, ITable } from "@gago/frame";
import wfBg from "./images/7@2x.png";

// tslint:disable-next-line:variable-name
export const BigScreenBody = styled.div<ColorProps<GlobalColorPalette>>`
  height: 100%;
  width: 100%;
  .header-box{
    height: 92px;
    width: 100%;
    background-color: #09131f;
    background-image: url("/static/images/header-top.png");
    background-repeat: no-repeat;
    background-size: contain;
  }
  .screen-body{
    height: calc(100% - 92px);
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: flex-start;
    .asider-left{
      flex: 1 0 auto;
      width: 460px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .left-chart{
        flex: 1 1 auto;
        height: 30%;
        margin-top: 16px;
        &:first-of-type{
          margin-top: 0px;
        }
      }
      .right-chart{
        height: 245px;
      }
      .right-top-chart{
        flex: 1 1 auto;
        height: 424px;
        .weather-forecast{
          height: 64px;
          width: 100%;
          background-image: url(${wfBg});
          background-color: rgba(0, 8, 15, 0.55);
          background-repeat: no-repeat;
          background-size: 100% 100%;
          font-size: 16px;
          color: #c2fffa;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .forecast-chart{
          height: calc(100% - 64px);
          padding-top: 12px;
        }
      }
    }
    .content-middle{
      padding: 24px;
      padding-bottom: 0;
      flex: 2 2 auto;
      width: 920px;
      .cm-top-box{
        height: 100px;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        .cmt-chart{
          width: 50%;
          height: 100%;
          flex: 1 1 auto;
          margin-right: 16px;
          &:last-child{
            margin-right: 0px;
          }
        }
      }
      .cm-map-box{
        margin-top: 24px;
        height: calc(100% - 124px);
        position: relative;
        .react-mapbox--container{
          .mapboxgl-canvas{
            outline: none;
            overflow: hidden;
          }
        }
        .timeline-box{
          position: absolute;
          bottom: 0px;
          left: 0px;
          right: 110px;
          background-color: rgb(5 22 33 / 20%);
        }
        .back-box{
          position: absolute;
          top: 40px;
          right: 3px;
          z-index: 99;
          cursor: pointer;
          user-select: none;
          width: 40px;
          height: 50px;
          border-radius: 6px;
          border: solid 1px 1px solid rgb(0 202 224 / 45%);
          color: #00cae0;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transition: all 0.25s ease-out;
          background-color: #122B45;
          &:hover{
            box-shadow: 0 0 6px rgb(0 202 224 / 80%);
          }
        }
        .cmb-select{
          position: absolute;
          top: 8px;
          left: 0;
          padding: 0;
          z-index: 99;
        }
        .cmb-select-second{
          position: absolute;
          top: 52px;
          left: 0;
          padding: 0;
          z-index: 99;
        }
        .auto-button{
          position: absolute;
          top: 0;
          right: 0;
          z-index: 99;
          width: 98px;
          height: 34px;
          background-image: url("/static/images/auto-button.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          user-select: none;
          outline: none;
          transition: all 0.25s ease-out;
          &:hover{
            background-image: url("/static/images/auto-button-active.png");
          }
        }
        .b-active{
          background-image: url("/static/images/auto-button-hover.png");
          &:hover{
            background-image: url("/static/images/auto-button-hover.png");
          }
        }
      }
    }
    .gauge-antd-border{
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .gauge-antd-box{

      }
    }
  }
`;

export const chart1N1D: ITable<1, 1> = {
  title: "8899",
  subtitle: "总面积(万亩)",
  head: ["ID", "类型", "面积"],
  range: [[], [], []],
  prefix: ["", "", ""],
  suffix: ["", "", "万亩"],
  defaultValue: [undefined, undefined, undefined],
  data: [
    ["", "耕地", 12345],
    ["", "林地", 12345],
    ["", "水域", 12345],
    ["", "城镇", 12345],
    ["", "草地", 12345],
    ["", "其它", 12345],
  ],
};

export const chart2N1D: ITable<2, 1> = {
  title: "",
  subtitle: "",
  head: ["ID", "类型", "年份", "单位"],
  range: [[], [], [], []],
  prefix: ["", "", "", ""],
  suffix: ["", "", "", "亩"],
  defaultValue: [undefined, undefined, undefined, undefined],
  data: [
    ["", "耕地", "2015", 2000],
    ["", "耕地", "2016", 1000],
    ["", "耕地", "2017", 2400],
    ["", "耕地", "2018", 1600],
    ["", "耕地", "2019", 1200],
    ["", "耕地", "2020", 2800],
  ],
};

export const chart1N2D: ITable<1, 2> = {
  title: "",
  subtitle: "",
  head: ["ID", "类型", "游客人数", "旅游收入"],
  range: [[], [], [], []],
  prefix: ["", "", "", ""],
  suffix: ["", "", "万人", "亿元"],
  defaultValue: [undefined, undefined, undefined, undefined],
  data: [
    ["", "荔城街道", 0, 0],
    ["", "增江街道", 0, 0],
    ["", "朱村街道", 0, 0],
    ["", "永宁街道", 0, 0],
    ["", "荔湖街道", 0, 0],
    ["", "宁西街道", 0, 0],
    ["", "新塘镇", 0, 0],
    ["", "石滩镇", 0, 0],
    ["", "中新镇", 0, 0],
    ["", "正果镇", 0, 0],
    ["", "派潭镇", 0, 0],
    ["", "小楼镇", 0, 0],
    ["", "仙村镇", 0, 0],
  ],
};

export const chart1N5D: ITable<1, 5> = {
  title: ``,
  subtitle: "",
  description: "",
  defaultValue: [0, 0, 0, 0, 0, 0, 0],
  range: [[], [], [], [], [], [], []],
  head: ["ID", "类型", "标记", "活动积温", "三年平均", "当前值", "增长率"],
  data: [["0", "活动积温", 0.3, 0.4, 300, 368, 0.21]],
  suffix: ["", "", "℃·d", "℃·d", "℃·d", "℃·d", "%"],
};

export const dataS4N5: ITable<5, 4> = {
  title: "天气预报",
  subtitle: "",
  description: "",
  defaultValue: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  range: [[], [], [], [], [], [], [], [], [], []],
  head: ["ID", "周几", "日期", "天气", "风向", "最高温", "最低温", "降雨", "风级", "湿度"],
  data: [
    ["", "星期二", "05/26", "多云", "北风转南风", "3-4级", 26, 16, 0, 67.06],
    ["", "星期三", "05/27", "多云", "北风转南风", "3-4级", 29, 16, 0, 53.04],
    ["", "星期四", "05/28", "多云", "南风", "3-4级", 33, 20, 0, 45.28],
    ["", "星期五", "05/29", "多云转晴", "南风", "3-4级", 34, 19, 0, 51.96],
    ["", "星期六", "05/30", "多云转小雨", "南风", "3-4级", 31, 18, 0.01, 55.82],
    ["", "星期日", "05/31", "小雨转晴", "北风转南风", "3-4级转<3级", 29, 19, 0.49, 62.8],
    ["", "星期一", "06/01", "小雨", "南风转东南风", "<3级转3-4级", 31, 21, 1.1, 52.38],
  ],
  suffix: ["", "", "", "", "级", "°", "°", "mm", "", "%"],
};

/** 地图类型数据列表 */
// tslint:disable:completed-docs
export const mapDataList: {label: string; value: string}[] = [
  { label: "资源分布", value: "资源分布" },
  { label: "水稻分布", value: "水稻分布" },
  { label: "气象预报", value: "气象预报" },
];
/** 地图类型播放事件类型轴 */
export const autoPlayTypeList = ["资源分布", "水稻分布", "气象预报"];

/** 气象预报类型数据列表 */
export const meteoDataList: {label: string; value: string}[] = [
  { label: "最高温", value: "最高温" },
  { label: "最低温", value: "最低温" },
  { label: "降水", value: "降水" },
];
